import $ from 'jquery';
import Animation from '../Scroll/_Animation';
// import Parallax from '../Scroll/_Parallax';
import Rellax from 'rellax';
import Page from '../Page/_State';

let ins;

class Scroll {
  constructor() {
    console.log('Scroll constructor');
    this.controller;
    this.parallaxIns;
    this.opDuration = 200;
    this.offsetNum = -($(window).height() / 4);
    this.isParallax = true;
    // this.isParallax = false;

    // $('.reset-re').click(function () {
    //   // scene.destroy(true);
    //   this.setController();
    //   // scene.refresh();
    //   // console.log(refresh);
    //   // sceneAry.forEach(element => element.refresh());
    // }.bind(this));

    // $('.reset-destroy').click(function () {
    //   // scene.destroy(true);
    //   this.destroyController();
    //   // scene.refresh();
    //   // console.log(refresh);
    //   // sceneAry.forEach(element => element.refresh());
    // }.bind(this));
  }

  reflesh() {
    console.log('[reflesh]');
    this.destroyController();
    this._setScene();
    this._parallaxReflesh(this.controller);
  }

  destroyController() {
    console.log('[destroyController]');
    this.controller.destroy(true);
  }

  setController() {
    console.log('[setController]');
    this._setScene();
    // $('.page-sekai-sen').addClass('page-sekai-sen--hide');
    this._setRellax();
    Page.ins.goTo('init');
  }

  _setScene() {
    this.controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      duration: this.opDuration,
      reverse: true,
    })
      .setClassToggle('.mv', 'mv--start')
      .addTo(this.controller);

    new ScrollMagic.Scene({
      offset: this.opDuration,
      reverse: true,
    })
      // .addIndicators({ name: 'KvFix' })
      .setTween(Animation.getKvFix())
      .setClassToggle('.mv', 'mv--fix')
      .addTo(this.controller);

    // MVがFIXしている間隔
    new ScrollMagic.Scene({
      duration: 900,
      reverse: true,
    })
      // .addIndicators({ name: 'mv fix' })
      .setPin('.mv')
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block1',
      reverse: true,
    })
      // .addIndicators({ name: 'pc logo' })
      .setTween(Animation.getPcBgLogoKokoro())
      .addTo(this.controller); // PCレイアウト左ロゴ

    new ScrollMagic.Scene({
      triggerElement: '.block1-koma1',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock1Koma1())
      // .addIndicators()
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block1-koma2-3',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock1Koma2_3())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block1-koma4',
      offset: this.offsetNum,
      reverse: true,
    })
      // .addIndicators()
      .setTween(Animation.getBlock1Koma4())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block1-koma5',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock1Koma5())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block1-koma6',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock1Koma6())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block1-koma7',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock1Koma7())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block2-photo',
      // offset: this.offsetNum,
      triggerHook: 'onEnter',
      reverse: true,
    })
      .setTween(Animation.getBlock2PhotoScale())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block2-koma1',
      offset: this.offsetNum,
      // triggerHook: 'onEnter',
      reverse: true,
    })
      .setTween(Animation.getBlock2Koma1Scale())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block2-koma2',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock2Koma2Fuyu())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block2-koma3',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock2Koma3Tyaku())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block2-koma4',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock2Koma4())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block3-txt',
      // offset: this.offsetNum,
      triggerHook: 'onEnter',
      reverse: true,
    })
      .setTween(Animation.getBlock3Txt())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block3-koma1',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock3Koma1())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.block3-koma1',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getBlock3Koma1())
      .addTo(this.controller);

    /*
    世界線に行く前にページ下に行った時 自動戻るスクロールに
     */
    this.pagetopCount = 0;
    new ScrollMagic.Scene({
      triggerElement: '.sekai-top-pagetop-auto',
      triggerHook: 'onEnter',
      duration: 150,
      reverse: true,
    })
      .on('enter', function () {
        this.pagetopCount = 0;
      })
      .on('progress', function () {
        this.pagetopCount++;
        // console.log('this.pagetopCount：' + this.pagetopCount);
        // 直接下部アンカーリンクを押したときは発動しない
        if ((Page.ins.status == 'top' || Page.ins.status == 'init') && this.pagetopCount == 2) {
          $('a[href="#loop"]').trigger('click');
        }
      })
      // .addIndicators({ name: 'auto scroll start' })
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.sekai-yume-koma1',
      triggerHook: 'onEnter',
      reverse: true,
    })
      .on('enter', function () {
        $('.sekai-yume-koma1 img').attr('style', '');
      })
      .setTween(Animation.getSekaiYumeKoma1())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.sekai-yume-koma2',
      triggerHook: 'onEnter',
      reverse: true,
    })
      .setTween(Animation.getSekaiYumeKoma2())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.sekai-yume-koma3',
      triggerHook: 'onEnter',
      reverse: true,
    })
      .setTween(Animation.getSekaiYumeKoma3())
      .addTo(this.controller);

    // new ScrollMagic.Scene({
    //   triggerElement: '.sekai-yume-koma4',
    //   // offset: this.offsetNum,
    //   // reverse: true,
    // })
    //   .setTween(Animation.getSekaiYumeKoma4())
    //   .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.sekai-kokoro-txt',
      offset: this.offsetNum,
      reverse: true,
    })
      .setTween(Animation.getSekaiKokoroTxt())
      .addTo(this.controller);

    new ScrollMagic.Scene({
      offset: 0,
      triggerHook: 'onLeave',
      triggerElement: '.shindan',
      reverse: true,
    })
      .setClassToggle('body', 'contents')
      .addTo(this.controller);
  }

  _setRellax() {
    if (!this.isParallax) return false;

    this.parallaxIns = new Rellax('.rellax', {
      center: true,
    });
    this.parallaxIns2 = new Rellax('.rellax2', {
      center: true,
    });
    // this._parallaxReflesh(this.controller);
  }

  _parallaxReflesh() {
    let parent = this;
    // parent.parallaxIns.refresh();

    // setTimeout(function(){
      // console.log('パララクス リフレッシュ');
    //   parent.parallaxIns.refresh();
    // },1000);

    // パララクス リフレッシュ
    // new ScrollMagic.Scene({
    //   triggerElement: '.block2',
    //   triggerHook: 'onEnter',
    //   reverse: true,
    // })
    //   .on('enter', function () {
    //     // console.log('パララクスリフレッシュ');
    //     parent.parallaxIns.refresh();
    //   })
    //   .addTo(this.controller);

    // new ScrollMagic.Scene({
    //   triggerElement: '.block3',
    //   triggerHook: 'onEnter',
    //   reverse: true,
    // })
    //   .on('enter', function () {
    //     // console.log('パララクスリフレッシュ');
    //     parent.parallaxIns.refresh();
    //   })
    //   .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.sekai-top',
      triggerHook: 'onEnter',
      reverse: true,
    })
      // .addIndicators()
      .on('enter', function () {
        // console.log('パララクスリフレッシュ');
        parent.parallaxIns2.refresh();
      })
      .addTo(this.controller);
  }
}
// });
//

// (() => {
//   $(window).on('load', function () {

//     // 強制的にページトップ
//     setTimeout(function () {
//       $('html,body').scrollTop(0);
//       // $('.nav').removeClass('nav--fixed');
//     }, 1000);

//     // マジックスクロールを実行
//     new Scroll();
//   });
// })();
//
//
(() => {
  ins = new Scroll();
})();

export default { ins };
